import styled from 'styled-components'
import { COLORS } from '../../../styles/colors'

export const StyledDateRangePicker = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
	align-items: center;
	width: fit-content;
`

export const InputContainer = styled.div`
	position: relative;
	width: auto;
`

export const DropdownContainer = styled.div<{
	$isOpen: boolean
	$top?: number
	$left?: number
}>`
	position: fixed;
	top: ${({ $top }) => ($top !== undefined ? `${$top}px` : 'auto')};
	left: ${({ $left }) => ($left !== undefined ? `${$left}px` : 'auto')};
	z-index: 9999;
	display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
	background: ${COLORS.white};
	border-radius: 12px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`

export const PresetsContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
`

export const ResetButton = styled.div`
	display: flex;
	align-items: center;
`
